import { orderBy } from 'lodash';

export const sortFunction = (arr = [], sortType, sortField) => {
  switch (sortType) {
    case 'string':
      return arr[sortField].toLowerCase();
    default:
      return arr[sortField];
  }
};

export const sort = (arr = [], sortType, sortField, sortDirection) => {
  return orderBy(
    arr,
    [team => sortFunction(team, sortType, sortField)],
    [sortDirection],
  );
};
